export default __webpack_public_path__ + "static/media/190629_190332_IMG_9280.c42bd51a.jpg";